let callbacks = {
  // sequence: {Function}
};
if (typeof window !== 'undefined') {
  let win = window;
  // cache global `onInvokeNotify`
  let _onInvokeNotify = win.onInvokeNotify;
  /**
   * 客户端回调JS的全局回调函数入口
   * @param  {String} sequence [description]
   * @param  {Number} code     [description]
   * @param  {String} result [description]
   */
  win.onInvokeNotify = (sequence, code, result) => {
    let callback = callbacks[sequence];
    _onInvokeNotify && _onInvokeNotify(sequence, code, result);
    if (callback) {
      callback(code, result);
      delete callbacks[sequence];
    }
  };
}

/**
 * 调用客户端的 `workbench` 方法
 * @param  {Object}   options
 * @param  {String}   options.module    对应 `workbench` 的模块
 * @param  {String}   options.api       具体的 API 名称
 * @param  {Object}   options.query     请求参数
 * @param  {String}   options.method    HTTP 请求方法
 * @param  {Object}   options.accountId 账号信息，主要用于 千牛企业版 调用 店铺版接口
 * @param  {String}   options.from      调用来源信息，用于打点
 * @param  {Function} options.callback  调用返回后需执行的回调函数
 */
function invokeNative(options) {
  let sequence = workbench.createSequenceId();
  let {module, api, query, method, accountId, from, callback} = options;
  let args;
  query = JSON.stringify(query);

  switch(module) {
    case 'top':
    case 'jdy':
      args = [sequence, api, query, method];
      break;
    case 'application':
      args = [sequence, api, query, from];
      break;
    default:
      args = [sequence, api, query];
      break;
  }

  if (accountId) {
    accountId = JSON.stringify(accountId);
    args.push(accountId);
  }

  if (callback) {
    callbacks[sequence] = callback;
  }

  workbench[module].invoke(...args);
}

export default (context, next) => {
  let {api, request, response, rawReq} = context;
  let {routes} = api;

  request.method = rawReq.method || 'POST';

  invokeNative({
    module: routes[0],
    api: api.uri,
    query: request.query || {},
    method: request.method,
    accountId: rawReq.accountId,
    from: rawReq.from || (workbench.jdy ? 'qn.pcCommon.0.0' : ''),
    callback(code, result) {
      context.rawRes = result;
      try {
        result = JSON.parse(result);
      } catch(ex) {
        console.warn(`[QN-SDK] Native response is not a legal json string.`, result);
      }
      if (code === 0) {
        response.body = result;
      } else {
        context.error = result;
      }
      next();
    }
  });
};



// WEBPACK FOOTER //
// ./src/middlewares/qianniu-pc-invoke-native.js